import { useState } from 'react';
import { Button } from '@/shared/components/ui/Button';
import { useManufacturers } from '../hooks/useAdmin';
import { ManufacturersTable } from './ManufacturersTable';
import { ManufacturerForm } from './ManufacturerForm';
import type { Manufacturer } from '../services/manufacturersService';

export function ManufacturersTab() {
  const { data: manufacturers, isLoading } = useManufacturers();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingManufacturer, setEditingManufacturer] = useState<
    Manufacturer | undefined
  >();

  const handleAdd = () => {
    setEditingManufacturer(undefined);
    setIsFormOpen(true);
  };

  const handleEdit = (manufacturer: Manufacturer) => {
    setEditingManufacturer(manufacturer);
    setIsFormOpen(true);
  };

  const handleClose = () => {
    setIsFormOpen(false);
    setEditingManufacturer(undefined);
  };

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">
            Manufacturers & Brands
          </h2>
          <p className="mt-1 text-sm text-gray-600">
            Manage frame manufacturers, brands, and ordering requirements
          </p>
        </div>
        <Button onClick={handleAdd}>Add Manufacturer</Button>
      </div>

      <ManufacturersTable
        manufacturers={manufacturers || []}
        onEdit={handleEdit}
        isLoading={isLoading}
      />

      <ManufacturerForm
        isOpen={isFormOpen}
        onClose={handleClose}
        manufacturer={editingManufacturer}
      />
    </div>
  );
}
